<button
    class="p-action-btn-floating"
    [attr.automation-id]="automationId"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled"
    type="button"
    (click)="onClick($event)"
>
    <p-icon [name]="iconName" size="sm" hoverColor="functional-default"></p-icon>
</button>
